import React from 'react';
import { Chip } from '@mui/material';

// Shared status/source -> label/color mapping so the list page and the detail
// drawer never drift apart on what a given finding looks like.

export function getStatusDisplay(finding) {
  if (finding.status === 'resolved') {
    return { label: 'Resolved', color: '#166534', bg: '#DCFCE7', border: '#BBE8C9' };
  }
  if (finding.status === 'ignored') {
    return { label: 'Ignored', color: '#52525B', bg: '#F1F0F3', border: '#E1DFE6' };
  }
  // status === 'open'
  if (finding.severity === 'error') {
    return { label: 'Error', color: '#9F1239', bg: '#FDE2E7', border: '#F8C7D2' };
  }
  return { label: 'Needs Review', color: '#92400E', bg: '#FEF3C7', border: '#FCE3A1' };
}

export function getSourceDisplay(source) {
  if (source === 'wix') {
    return { label: 'Wix', color: '#0F766E', bg: '#E6F7F5', border: '#BFEDE7' };
  }
  if (source === 'user') {
    return { label: 'User', color: '#B45309', bg: '#FEF3C7', border: '#FCE3A1' };
  }
  if (source === 'stripe') {
    return { label: 'Stripe', color: '#4338CA', bg: '#EEF0FC', border: '#D9DCF7' };
  }
  return { label: source || 'Unknown', color: '#52525B', bg: '#F1F0F3', border: '#E1DFE6' };
}

function Pill({ label, color, bg, border }) {
  return (
    <Chip
      label={label}
      size="small"
      sx={{
        color,
        backgroundColor: bg,
        border: `1px solid ${border}`,
        fontWeight: 600,
        fontSize: '12px',
      }}
    />
  );
}

export function StatusChip({ finding }) {
  return <Pill {...getStatusDisplay(finding)} />;
}

export function SourceChip({ source }) {
  return <Pill {...getSourceDisplay(source)} />;
}
